import { useContext } from "react";

import { FormFieldContext, type FormFieldContextValue } from "./_context";

export function useFormFieldContext(): undefined | FormFieldContextValue {
	return useContext(FormFieldContext);
}
